import { c as _c } from "react/compiler-runtime";
import { toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { CONTACT_API } from 'modules/contacts/api/contact-api';
import { ImportContactsErrorResponseContentInterface, SendImportContactsJsonData } from 'modules/contacts/contacts-import/hook/use-send-import-contacts/types';
import { transformSendImportContactsJsonDataToFormData } from 'modules/contacts/contacts-import/hook/use-send-import-contacts/utils';
import { ContactsImportTableColumnId } from 'modules/contacts/contacts-import/types/contacts-import-column-select';
import { ContactsImportStatus, ContactsLastImportsInterface } from 'modules/contacts/contacts-import/types/contacts-import-interface';
import React, { useState } from 'react';
import TransLoco from 'shared/components/trans-loco';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { HTMLString } from 'shared/types/html-string';
import { getContactsPageNextjsUrl } from '../../../utils/get-contacts-page-nextjs-url';
export function useSendImportContacts() {
  const $ = _c(9);
  const {
    t
  } = useLocoTranslation();
  const [errors, setErrors] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.postForm
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher || $[2] !== t) {
    t1 = async data => {
      ;
      try {
        setErrors(null);
        const formData = await transformSendImportContactsJsonDataToFormData(data);
        const newImportContactsData = await fetcher(`${CONTACT_API}/contacts/import`, formData);
        bb50: switch (newImportContactsData.status) {
          case ContactsImportStatus.suspended:
            {
              toast.success(t("dashboard.contact_import.suspended_message"));
              break bb50;
            }
          case ContactsImportStatus.approved:
            {
              toast.success(<TransLoco t={t} i18nKey="dashboard.contact_import.form.toast.importing_your_contacts" components={{
                a: <a href={`/dashboard${getContactsPageNextjsUrl()}`} target="_blank" rel="noreferrer" />
              }} />);
              break bb50;
            }
          case ContactsImportStatus.failed:
            {
              toast.error(t("global.error"));
            }
        }
      } catch (t2) {
        const e = t2;
        if (e instanceof BadRequest) {
          const errors_0 = e.errors as ImportContactsErrorResponseContentInterface;
          const {
            mapColumns,
            ...rest
          } = errors_0.fields;
          setErrors(prevError => ({
            ...prevError,
            common: errors_0.common.join("\n"),
            columns: Object.entries(mapColumns?.columns || {})?.reduce(_temp, {})
          }));
          Object.entries(rest).forEach(_temp2);
        }
        throw e;
      }
    };
    $[1] = fetcher;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setErrors(null);
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== errors || $[6] !== isFetching || $[7] !== t1) {
    t3 = {
      fetcherSendImportContacts: t1,
      isSendImportContactsFetching: isFetching,
      sendImportContactsError: errors,
      resetSendImportContactsError: t2
    };
    $[5] = errors;
    $[6] = isFetching;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp2(el) {
  toast.error(el.join("\n"));
}
function _temp(resColumns, t0) {
  const [key, value] = t0;
  return {
    ...resColumns,
    [key]: value?.join("")
  };
}